<template>

	<div class="w-full">

        <div class="w-full text-center" v-if="loading">
            <div class="py-5" colspan="4">
                <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
            </div>
        </div>

        <!-- chasers -->
        <div class="flex flex-wrap" v-if="announcement.length !== 0">
            <div class="w-full bg-white rounded-lg shadow p-6 mb-6">
                <h3 class="text-lg md:text-xl font-semibold pb-3 border-b-2 border-grey-lighter mb-4 relative">
                    {{ announcement.title }} <small> by {{announcement.sender.name}}</small>

					<div class="w-full text-sm md:text-xl md:w-auto md:absolute md:top-0 md:right-0">
						{{ announcement.created_at | displayLocalDateTime }}
					</div>
                </h3>
                <div class="w-full">
                    <p style="white-space: pre-wrap;">{{announcement.message}}</p>
                </div>
                <div class="w-full mt-10">
                    <span class="text-gray-600 text-uppercase text-sm font-semibold">Viewed By {{ announcement.receipts.length }}</span>
                    <AnnouncementReceipt :receipts="announcement.receipts" v-if="announcement.receipts.length !== 0"/>
                    <div class="w-full" v-if="announcement.receipts.length == 0">
                        <span>Looks like you're the first!</span>
                    </div>
                </div>
                <div class="w-full mt-5">
                    <span class="text-gray-600 text-uppercase text-sm font-semibold inline-block">Live Storms Media Disclaimers</span> <br>
                    <ul class="text-xs list-disc pl-6">
                        <li>Any views or opinions presented in this posting, and/or comments, are solely those of the author(s) and do not necessarily represent the views of Live Storms Media.</li>
                        <li>CONFIDENTIALITY: This posting (including any attachments or comments within) may contain confidential, proprietary and privileged information, and unauthorized disclosure or use is prohibited. If you received this in error, please notify the sender and delete from your system. Thank you.</li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- chasers -->
        <div class="flex flex-wrap" v-if="announcement.length !== 0">
            <div class="w-full bg-white rounded-lg shadow p-6 mb-6">
                <h3 class="text-lg md:text-xl font-semibold pb-3 border-b-2 border-grey-lighter mb-4 relative">
                    Discussion
                    <div class="text-sm absolute top-0 right-0">
                        <button class="px-2 py-1 text-blue-700 text-lg focus:outline-none" v-if="!announcement.isSubscribedToNotifications" v-on:click="subscribeToNotifications()" title="Subscribe to notifications for this post" v-tippy>
                            <i class="fa fa-bell"></i>
                        </button>
                        <button class="px-2 py-1 text-red-700 text-lg focus:outline-none" v-if="announcement.isSubscribedToNotifications" v-on:click="unSubscribeToNotifications()"  title="Unsubscribe from notifications for this post" v-tippy>
                            <i class="fa fa-bell-slash"></i>
                        </button>
					</div>
                </h3>
                <div class="w-full">

                    <!-- comments -->
                    <div class="w-full mb-4" v-for="comment in announcement.comments">
                        <div class="w-full">
                            <strong class="mr-2">{{ comment.sender.name }}</strong>
                            <span :title="displayLocalDateTime(comment.created_at)" v-tippy>{{ comment.created_at | timeAgo}} </span>
                        </div>
                        <div v-html="comment.message" v-linkified:options="{ className: 'text-blue-700' }" />
                    </div>

                    <div class="w-full" v-if="announcement.comments.length == 0">
                        There are no comments. Add a comment to be the first.
                    </div>

                    <!-- compose comment -->
                    <div class="w-full mt-5">
                        <h4 class="text-md font-semibold mb-2">Add to the discussion...</h4>
                        <textarea class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" rows="4" v-model="composeComment"></textarea>
                        <button class="bg-blue-700 px-3 py-1 text-white rounded" v-on:click="addComment()">
                            Comment
                        </button>
                    
                    </div>


                </div>
            </div>
        </div>


    </div>

</template>

<script>

	import * as Config from '@/config'
	import { mapState, mapGetters } from 'vuex';
	import { EventBus } from '@/utils/events';

    import moment from 'moment';
    import AnnouncementReceipt from '@/components/general/AnnouncementReceipt'

	export default {
		name: 'AnnouncementView',
		data () {
			return {
				announcement: [],
                loading: true,
                composeComment: '',
			}
		},
		mounted() {
			this.getAnnouncement();
        },
        components: {
            AnnouncementReceipt
        },
		methods: {
			...mapGetters([
                'getAuthorizationHeader',
			]),
			getAnnouncement() {
                this.$http.get(Config.apiPath + "/api/v2/stringer/announcements/" + this.$route.params.uuid, this.getAuthorizationHeader()).then((response) => {
					this.$set(this, 'announcement', response.data)
                    this.$set(this, 'loading', false)
                });
            },
            addComment() {
                var userText = this.composeComment.replace(/^\s+/, '').replace(/\s+$/, '');
                if(userText == '') {
                    this.$swal(
                        'Hmm!',
                        'Your comment must have substance. Come on, no ghosts allowed.',
                        'error'
                    )
                    return;
                }

                var _this = this
               
                this.$http.post(Config.apiPath + "/api/v2/stringer/announcements/" + this.$route.params.uuid, { comment: this.composeComment }, this.getAuthorizationHeader()).then((response) => {
                    _this.$swal({
                        title: "Sent!",
                        text: "Would you like to receive updates when others discuss? You can always disable updates later on!",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, enable notifications.'
                    })
                    .then((result) => {
                        if (result.value) {
                            _this.subscribeToNotifications()
                        }
                    });

                    _this.getAnnouncement()
                    _this.composeComment = ''
                });
            },
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm a');
            },
            subscribeToNotifications() {
                var _this = this
                this.$http.post(Config.apiPath + "/api/v2/stringer/announcements/" + this.$route.params.uuid + "/subscribe", { }, this.getAuthorizationHeader()).then((response) => {
                    _this.$swal(
                        'Subscribed to Notifications',
                        'You will now get updates when comments are made on this post.',
                        'success'
                    )
                    _this.announcement.isSubscribedToNotifications = true
                });
            },
            unSubscribeToNotifications() {
                var _this = this
                this.$http.post(Config.apiPath + "/api/v2/stringer/announcements/" + this.$route.params.uuid + "/unsubscribe", { }, this.getAuthorizationHeader()).then((response) => {
                    _this.$swal(
                        'Unsubscribed from Notifications',
                        'You have been unsubscribed from notifications.',
                        'success'
                    )
                    _this.announcement.isSubscribedToNotifications = false
                });
            }
		},
		filters: {
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm a');
            },
            timeAgo: function(date) {
                return moment.utc(date).fromNow();
            },
        }
		
	}
</script>

<style scoped>

	.user-panel {
		background-color: #F6F7F8;
	}

</style>
